import React, { useContext, useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { FilterContext } from "../../context/Filter";

const StatewiseTable = ({ complaintsDivisionTableStateFilterData }) => {
  const flattenedData = useMemo(() => {
    if (!complaintsDivisionTableStateFilterData) return [];
    return complaintsDivisionTableStateFilterData.map((item) => ({
      ...item.key,
      doc_count: item.doc_count,
    }));
  }, [complaintsDivisionTableStateFilterData]);

  const columns = useMemo(() => {
    if (!flattenedData.length) return [];

    return Object.keys(flattenedData[0]).map((key) => ({
      accessorKey: key,
      header: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()), // Title Case
      cell: (info) => info.getValue(),
    }));
  }, [flattenedData]);

  const table = useReactTable({
    data: flattenedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (!flattenedData.length) {
    return <div className="p-4 text-gray-500">No data available</div>;
  }

  return (
    <div className="border rounded overflow-hidden">
      <div className="max-h-[315px] overflow-y-auto">
        <table className="w-full border text-sm table-fixed">
          <thead className="bg-gray-200 sticky top-0 z-10">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border px-3 py-2 text-left font-medium bg-gray-100"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, rowIndex) => (
              <tr
                key={row.id}
                className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                {row.getVisibleCells().map((cell) => {
                  const value = cell.getValue()?.toString() || "";
                  return (
                    <td
                      key={cell.id}
                      className="border px-3 py-2 text-left truncate"
                      title={value}
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatewiseTable;
